export class Constants {

  private constructor() {
    // to avoid instantiation
  }

  public static readonly localStorageKeys = {
    PASSPORT_PROFILE: 'passportProfile'
  };
}

export enum PopupType {
  EVENT_REVIEW = 'EVENT_REVIEW'
}

export enum InvitationSource {
  DEFAULT = "DEFAULT",
	WATCH_PARTY = "WATCH_PARTY",
	SCREENING_PARTY = "SCREENING_PARTY",
	SPOTLIGHT_EVENT = "SPOTLIGHT_EVENT"
}

export enum WatchPartyRequestFlow {
  NEW_WATCH_PARTY = "NEW_WATCH_PARTY",
  NEW_PARTICIPANT_ADDED = "NEW_PARTICIPANT_ADDED"
}
